<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link" aria-current="page" routerLink="/" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">Home</a>
        </li>
        <li class="nav-item" *ngIf="isLoggedIn">
          <a class="nav-link" aria-current="page" routerLink="/product-catalog" [routerLinkActive]="['active']">Product Catalog</a>
        </li>
        <!--<li class="nav-item">
          <a class="nav-link" aria-current="page" routerLink="/select-stations" [routerLinkActive]="['active']">Explore Data</a>
        </li>-->
        <li class="nav-item">
          <a class="nav-link" aria-current="page" routerLink="/graph" [routerLinkActive]="['active']">Explore Graph</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" aria-current="page" routerLink="/spatial-data" [routerLinkActive]="['active']">Spatial Data</a>
        </li>
      </ul>
      <ul class="navbar-nav mb-2 mb-lg-0 me-5">
        <li class="nav-item">
          <a class="nav-link" aria-current="page" routerLink="/login" [routerLinkActive]="['active']" *ngIf="!isLoggedIn">Login</a>
        </li>
        <li class="nav-item d-flex align-items-center me-3 nav-text" *ngIf="isLoggedIn">{{ user.name }} ({{ user.role }})</li>
        <li class="nav-item">
          <a class="nav-link" aria-current="page" (click)="onLogout()" *ngIf="isLoggedIn">
            <div>Logout</div>
          </a>
        </li>
      </ul>
    </div>
    <a class="navbar-brand" href="/">
      <img src="https://www.ocean.org.il/wp-content/themes/Ocean/images/logo.png" alt="חקר הימים">
    </a>
  </div>
</nav>
